import React from 'react';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import Image from 'marketing-website/components/modules/Image';
import WistiaVideo from 'marketing-website/components/modules/Integrations/Video';

import assets from 'marketing-website/configs/pages/enterprise/assets';

import styles from './style/header.module.css';

export default function Header() {
  const icon = (
    <svg
      width="11"
      height="13"
      viewBox="0 0 11 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.656 6.016c.219.172.344.453.344.734 0 .281-.125.563-.344.75-.156.125-4.016 3.375-9.047 5.422-.125.047-.25.078-.391.078-.172 0-.359-.047-.516-.141-.266-.156-.453-.438-.469-.75-.016-.109-.234-2.641-.234-5.359 0-2.719.219-5.25.234-5.344.016-.313.203-.594.469-.766.156-.094.328-.141.516-.141.125 0 .266.031.391.078 5.031 2.047 8.891 5.297 9.047 5.438z"
        fill="#0C1014"
      />
    </svg>
  );

  const buttons = (
    <Spacing size="m" sizeM="l" position="top" type="margin">
      <div className={styles.buttons}>
        <div className={styles.leftButton}>
          <Link to="/enterprise/request-demo">
            <Button
              size="large"
              background="blue"
              hover="blue"
              shape="rounded"
              minWidth={180}
            >
              Request a demo
            </Button>
          </Link>
        </div>
        <div className={styles.rightButton}>
          <WistiaVideo
            id={'ijlaqk4xz2'}
            childButton={
              <div className={styles.hackyButton}>
                <Button
                  size="large"
                  kind="ghost"
                  hover="green"
                  shape="rounded"
                  icon={icon}
                  minWidth={180}
                  isIconCentered
                >
                  Watch video
                </Button>
              </div>
            }
          />
        </div>
      </div>
    </Spacing>
  );
  return (
    <PageWrap size="l">
      <div className={styles.flex}>
        <div className={styles.firstCol}>
          <div>
            <Heading tag="h1" size="xxxxl" weight="bold" color="black">
              Design, test and ship amazing products at scale with Marvel
            </Heading>
            <Spacing size="s" position="top" type="margin">
              <Heading tag="h2" size="xxl">
                Marvel Enterprise transforms your design process, leading to
                better products, faster.
              </Heading>
            </Spacing>
            {buttons}
          </div>
        </div>
        <div className={styles.secondCol}>
          <div className={styles.blueBackground}>
            <div className={styles.blueChild} />
          </div>
          <div className={styles.image}>
            <div className={styles.imageChild}>
              <Image {...assets.dashboard} hasShadow={false} block />
            </div>
          </div>
        </div>
      </div>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/enterprise/Header.js